export default __webpack_public_path__ + "static/media/modal-events.aac9d854.svg";